module.exports = "/_next/static/images/top-caf2e682d905cebd345eef35bb160d87.jpg";